import React from 'react'
import { categoryMeta, count, fieldChips, rate } from './model'

// "Why they were blocked": one bar per reason, coloured by its category,
// each a share of everything blocked. Clicking a reason filters the whole
// screen by it (and clicking it again clears that). Under it, the fields
// that failed, added up across reasons.
export default function ReasonsCard({ reasons = [], selected = [], onSelect }) {
  const chips = fieldChips(reasons)
  return (
    <section className="card" aria-labelledby="bk-reasons-title" style={{ padding: 18, display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div className="bk-card-head">
        <h2 id="bk-reasons-title" style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Why they were blocked</h2>
        <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Click a reason to filter</span>
      </div>

      {reasons.length === 0 ? (
        <p style={{ margin: 0, fontSize: 13, color: 'var(--text-muted)' }}>Nothing was blocked in this range.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {reasons.map((r) => {
            const meta = categoryMeta(r.category)
            const active = selected.includes(r.code)
            return (
              <button
                key={r.code}
                type="button"
                className="bk-reason"
                data-category={meta.id}
                aria-pressed={active}
                aria-label={`${r.label}: ${count(r.count)} blocked, ${rate(r.pct)}`}
                onClick={() => onSelect(r.code)}
              >
                <span style={{ display: 'flex', justifyContent: 'space-between', gap: 10, fontSize: 13 }}>
                  <span style={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.label}</span>
                  <span style={{ fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap', color: 'var(--text-secondary)' }}>
                    <strong style={{ color: 'var(--text-primary)' }}>{count(r.count)}</strong> · {rate(r.pct)}
                  </span>
                </span>
                <span className="bk-track" aria-hidden="true">
                  <span
                    data-testid={`reason-bar-${r.code}`}
                    style={{ display: 'block', height: '100%', width: `${Math.min(100, Math.max(0, Number(r.pct || 0) * 100))}%`, minWidth: r.count > 0 ? 3 : 0, background: meta.color, borderRadius: 99 }}
                  />
                </span>
              </button>
            )
          })}
        </div>
      )}

      {chips.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, borderTop: '1px solid var(--border)', paddingTop: 12 }}>
          <h3 style={{ margin: 0, fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--text-muted)' }}>
            Missing or invalid fields
          </h3>
          <ul aria-label="Missing or invalid fields" style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {chips.map((c) => (
              <li key={`${c.kind}|${c.field}`} className="bk-chip">
                <span className="bk-mono" style={{ color: 'var(--text-primary)' }}>{c.field}</span>
                {c.kind === 'invalid' && <span style={{ fontSize: 11, color: 'var(--amber)' }}>invalid</span>}
                <span style={{ fontVariantNumeric: 'tabular-nums' }}>· {count(c.count)}</span>
              </li>
            ))}
          </ul>
          <p style={{ margin: 0, fontSize: 11, color: 'var(--text-muted)' }}>
            Only the first invalid field of each submission is recorded.
          </p>
        </div>
      )}
    </section>
  )
}
